var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useContext, useId } from 'react';
import { Icon } from '@sb1/ffe-icons-react';
import { Collapse } from '@sb1/ffe-collapse-react';
import classNames from 'classnames';
import { AccordionContext } from './AccordionContext';
export var AccordionItem = function (_a) {
    var children = _a.children, heading = _a.heading, defaultOpen = _a.defaultOpen, isOpen = _a.isOpen, className = _a.className, _b = _a.onToggleOpen, onToggleOpen = _b === void 0 ? Function.prototype : _b, ariaLabel = _a.ariaLabel, rest = __rest(_a, ["children", "heading", "defaultOpen", "isOpen", "className", "onToggleOpen", "ariaLabel"]);
    var _c = useState(defaultOpen), isExpanded = _c[0], setIsExpanded = _c[1];
    var _d = useState(false), isAnimating = _d[0], setIsAnimating = _d[1];
    var _e = useState(false), isFocused = _e[0], setFocus = _e[1];
    var buttonId = useId();
    var contentId = useId();
    var headingLevel = useContext(AccordionContext).headingLevel;
    var expandMoreIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik00ODAtMzczLjUzOXEtNy4yMzEgMC0xMy40NjEtMi4zMDgtNi4yMzEtMi4zMDgtMTEuODQ2LTcuOTIzTDI3NC45MjQtNTYzLjUzOXEtOC4zMDgtOC4zMDctOC41LTIwLjg4NC0uMTkzLTEyLjU3NyA4LjUtMjEuMjY5IDguNjkyLTguNjkyIDIxLjA3Ni04LjY5MnQyMS4wNzYgOC42OTJMNDgwLTQ0Mi43NjhsMTYyLjkyNC0xNjIuOTI0cTguMzA3LTguMzA3IDIwLjg4NC04LjUgMTIuNTc2LS4xOTIgMjEuMjY4IDguNSA4LjY5MyA4LjY5MiA4LjY5MyAyMS4wNzcgMCAxMi4zODQtOC42OTMgMjEuMDc2TDUwNS4zMDctMzgzLjc3cS01LjYxNSA1LjYxNS0xMS44NDYgNy45MjMtNi4yMyAyLjMwOC0xMy40NjEgMi4zMDhaIi8+PC9zdmc+';
    useEffect(function () {
        if (isOpen != null) {
            setIsAnimating(true);
            setIsExpanded(isOpen);
        }
    }, [isOpen]);
    var handleOnClick = function () {
        onToggleOpen(!isExpanded);
        if (isOpen == null) {
            setIsAnimating(true);
            setIsExpanded(!isExpanded);
        }
    };
    var collapseHidden = !isExpanded && !isAnimating;
    return (React.createElement("div", __assign({ className: classNames(className, 'ffe-accordion-item', {
            'ffe-accordion-item--open': isExpanded,
            'ffe-accordion-item--focus': isFocused,
        }) }, rest),
        React.createElement("h".concat(headingLevel), { className: 'ffe-h6 ffe-accordion-item__heading' }, React.createElement("button", { type: "button", id: buttonId, "aria-expanded": isExpanded ? 'true' : 'false', "aria-controls": contentId, "aria-label": ariaLabel, className: classNames('ffe-accordion-item__heading-button', {
                'ffe-accordion-item__heading-button--open': isExpanded,
            }), onClick: handleOnClick, onFocus: function () { return setFocus(true); }, onBlur: function () { return setFocus(false); } },
            React.createElement("span", { className: "ffe-accordion-item__heading-button-content" },
                heading,
                React.createElement("span", { className: "ffe-accordion-item__heading-icon-wrapper" },
                    React.createElement(Icon, { className: "ffe-accordion-item__heading-icon", fileUrl: expandMoreIcon, size: "sm" }))))),
        React.createElement(Collapse, { isOpen: !!isExpanded, onRest: function () { return setIsAnimating(false); }, id: contentId, "aria-labelledby": buttonId, role: "region" }, !collapseHidden && (React.createElement("div", { className: "ffe-accordion-item__body" }, children)))));
};
